import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Flame } from "lucide-react";

export function PrioridadToggle({ order, area, onChanged }) {
  const campo = `prioridad_${area}`;
  const on = !!order[campo];
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      await api.patch(`/orders/${order.id}/prioridad`, { area, valor: !on });
      onChanged({ [campo]: !on });
      toast.success(!on ? "Marcado como prioritario" : "Prioridad quitada");
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      className={`mt-1 inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide transition-colors ${on ? "bg-red-600 text-white border-red-700" : "bg-white text-zinc-600 border-zinc-300 hover:text-red-600 hover:border-red-400"}`}
      data-testid={`prio-${area}-${order.numero}`}
    >
      <Flame className="w-2.5 h-2.5" /> {on ? "Prioritario" : "Prioridad"}
    </button>
  );
}

export const PrioBadge = ({ show }) => (show ? (
  <span className="inline-flex items-center gap-0.5 rounded bg-red-600 text-white text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 mt-1" data-testid="prio-badge">
    <Flame className="w-2.5 h-2.5" /> Prioritario
  </span>
) : null);
